import { del, get, patch, post, put } from "src/services/api";

const fetchBenchmarksSetup = async (assistantId) => {
  const endpoint = `metrics/benchmarks/assistants/${assistantId}/setup`;
  return await get({ endpoint });
};

const fetchBenchmarkDefaults = async () =>
  await get({ endpoint: "metrics/benchmarks/defaults" });

const fetchBenchmarkOverrides = async (assistantId, benchmarksSetupId) =>
  await get({
    endpoint: "metrics/benchmarks/overrides",
    params: { assistantId, benchmarksSetupId }
  });

const fetchAllSetups = async () =>
  await get({ endpoint: "metrics/benchmarks/setups" });

const upsertBenchmarksSetup = async (assistantId, data) =>
  await put({ endpoint: `metrics/benchmarks/assistants/${assistantId}/setup`, data });

const createBenchmarkOverride = async (data) =>
  await post({ endpoint: "metrics/benchmarks/overrides", data });

const updateBenchmarkOverride = async (data) =>
  await patch({ endpoint: "metrics/benchmarks/overrides", data });

const deleteBenchmarkOverride = async (data) =>
  await del({ endpoint: "metrics/benchmarks/overrides", data });

export default {
  fetchBenchmarksSetup,
  fetchBenchmarkDefaults,
  fetchBenchmarkOverrides,
  fetchAllSetups,
  upsertBenchmarksSetup,
  createBenchmarkOverride,
  updateBenchmarkOverride,
  deleteBenchmarkOverride
};
